import { Grid2, Typography, Modal } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddButton from "../themes/overrides/AddButton";
import DeleteButton from '../themes/overrides/DeleteButton';
import ModalBox from "../themes/overrides/ModalBox";
import cancelIcon from "../assets/images/redo.svg";
import PropTypes from 'prop-types';
import LoadingOverlay from "./LoadingOverlay";

const DeleteConfirmationModal = ({ open, onClose, text, onConfirm, startIcon = null, deleteButtonLabel, loading }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Modal open={open} onClose={onClose}>
            <ModalBox sx={{ width: '520px', maxWidth: '95%' }}>
                <Typography variant="h2" sx={{ mb: 1 }}>
                    Confirm Delete
                </Typography>
                <Grid2>
                    <Typography>
                        <span>{text}</span>
                    </Typography>

                    <Grid2 sx={{
                        mt: 4, display: 'flex',
                        flexDirection: {
                            xs: 'column',
                            md: 'row',
                        },
                        justifyContent: 'space-between'
                    }}>
                        <AddButton
                            startIcon={
                                <img
                                    src={cancelIcon}
                                    alt="Cancel Icon"
                                    style={{ width: 24, height: 24 }}
                                />
                            }
                            label="Cancel"
                            sx={{ fontSize: '16px', width: { xs: '100%', md: '150px' } }}
                            onClick={onClose}
                        />
                        <DeleteButton
                            startIcon={startIcon}
                            label={deleteButtonLabel}
                            sx={{ fontSize: '16px', color: "#960101", border: "1.5px solid", width: { xs: '100%', md: '150px' }, mt: isMobile ? 1 : 0, }}
                            onClick={onConfirm}
                        />
                    </Grid2>
                </Grid2>
                {loading && <LoadingOverlay />}
            </ModalBox>
        </Modal>
    );
};

DeleteConfirmationModal.propTypes = {
    open: PropTypes.any,
    onClose: PropTypes.func,
    text: PropTypes.string,
    onConfirm: PropTypes.func,
    startIcon: PropTypes.any,
    deleteButtonLabel: PropTypes.string
};

export default DeleteConfirmationModal;